/* eslint-disable @typescript-eslint/no-namespace */
import { cloneDeep } from 'lodash';

import { CalendarFiltersState } from '../../state/calendar-filter/state';
import { FilterType } from '../../grid/utils/filter/filter.utils';
import { MonitorFiltersState } from '../../state/monitor-filters/state';
import { AdvancedFilterName } from './filter-types';
import { CalendarGridColumnName } from '../../grid/types/column.types';

type FilterState = CalendarFiltersState | MonitorFiltersState;

export namespace ServiceFilters {
  export function getExclusiveFilterName(filterName: string): string | null {
    switch (filterName) {
      case AdvancedFilterName.maturityYear:
        return CalendarGridColumnName.Structure;
      default:
        return null;
    }
  }
  export function applyServiceFilters(
    from: FilterState,
    to: FilterState
  ): FilterState {
    const serviceFiltersState = getServiceFiltersState(from);
    const result = { ...to };

    for (const key in serviceFiltersState) {
      if (Object.prototype.hasOwnProperty.call(serviceFiltersState, key)) {
        const shouldBeRemoved = getExclusiveFilterName(key);
        delete result[shouldBeRemoved];
        result[key] = cloneDeep(serviceFiltersState[key]);
      }
    }

    return result;
  }
  export function removeServiceFiltersState(
    filterState: FilterState
  ): FilterState {
    const result = {};
    for (const filterName in filterState) {
      if (
        Object.prototype.hasOwnProperty.call(filterState, filterName) &&
        filterState[filterName].type !== FilterType.ServiceFilter
      ) {
        result[filterName] = cloneDeep(filterState[filterName]);
      }
    }
    return result;
  }

  export function getServiceFiltersState(
    filterState: FilterState
  ): FilterState {
    const result = {};
    for (const filterName in filterState) {
      if (
        Object.prototype.hasOwnProperty.call(filterState, filterName) &&
        filterState[filterName].type === FilterType.ServiceFilter
      ) {
        result[filterName] = cloneDeep(filterState[filterName]);
      }
    }
    return result;
  }
}
